import { cx } from "@linaria/core";
import { type ButtonHTMLAttributes } from "react";

import { Chevron } from "./chevron";
import * as styles from "./circular.style";
import { resets } from "../css-tokens/resets";

type Props = {
  as?: "button" | "div";

  inversed?: boolean;
} & ButtonHTMLAttributes<HTMLElement>;

export const CircularButton = function CircularButton({
  ref,
  inversed,
  as,
  ...props
}: Props & {
  ref?: React.RefObject<HTMLElement | null>;
}): React.JSX.Element {
  const Comp = as ?? "button";

  return (
    <Comp
      // @ts-expect-error We should be allowed to type our ref as an
      // HTMLElement
      ref={ref}
      {...props}
      className={cx(
        styles.wrapper,
        resets.button,
        props.className,
        inversed && "inversed",
      )}
      onClick={props.onClick}
      aria-disabled={props.disabled}
    >
      <Chevron lineWidth={1.5} size={12} inversed={inversed} />
    </Comp>
  );
};
